module.exports = __webpack_public_path__ + "static/media/mockup.8f723166.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/mockup.png
// module id = 618
// module chunks = 0